/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiLeagueIdsIdsGet200Response } from '../models';
// @ts-ignore
import type { ApiLeagueLeagueIdGet200Response } from '../models';
// @ts-ignore
import type { ApiLeagueSeasonSeasonIdEventsGet200Response } from '../models';
/**
 * LeagueApi - axios parameter creator
 * @export
 */
export const LeagueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueIdsIdsGet: async (ids: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('apiLeagueIdsIdsGet', 'ids', ids)
            const localVarPath = `/api/league/ids/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get league by id from Sportradar API
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueLeagueIdGet: async (leagueId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leagueId' is not null or undefined
            assertParamExists('apiLeagueLeagueIdGet', 'leagueId', leagueId)
            const localVarPath = `/api/league/{league_id}`
                .replace(`{${"league_id"}}`, encodeURIComponent(String(leagueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get season events by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueSeasonSeasonIdEventsGet: async (seasonId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('apiLeagueSeasonSeasonIdEventsGet', 'seasonId', seasonId)
            const localVarPath = `/api/league/season/{season_id}/events`
                .replace(`{${"season_id"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeagueApi - functional programming interface
 * @export
 */
export const LeagueApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeagueApiAxiosParamCreator(configuration)
    return {
        /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeagueIdsIdsGet(ids: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLeagueIdsIdsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLeagueIdsIdsGet(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeagueApi.apiLeagueIdsIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get league by id from Sportradar API
         * @param {string} leagueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeagueLeagueIdGet(leagueId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLeagueLeagueIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLeagueLeagueIdGet(leagueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeagueApi.apiLeagueLeagueIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get season events by id from Sportradar API
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLeagueSeasonSeasonIdEventsGet(seasonId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLeagueSeasonSeasonIdEventsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLeagueSeasonSeasonIdEventsGet(seasonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeagueApi.apiLeagueSeasonSeasonIdEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LeagueApi - factory interface
 * @export
 */
export const LeagueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeagueApiFp(configuration)
    return {
        /**
         * Get league by ids separated by \",\" from Sportradar API
         * @param {LeagueApiApiLeagueIdsIdsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueIdsIdsGet(requestParameters: LeagueApiApiLeagueIdsIdsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLeagueIdsIdsGet200Response> {
            return localVarFp.apiLeagueIdsIdsGet(requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Get league by id from Sportradar API
         * @param {LeagueApiApiLeagueLeagueIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueLeagueIdGet(requestParameters: LeagueApiApiLeagueLeagueIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLeagueLeagueIdGet200Response> {
            return localVarFp.apiLeagueLeagueIdGet(requestParameters.leagueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get season events by id from Sportradar API
         * @param {LeagueApiApiLeagueSeasonSeasonIdEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLeagueSeasonSeasonIdEventsGet(requestParameters: LeagueApiApiLeagueSeasonSeasonIdEventsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLeagueSeasonSeasonIdEventsGet200Response> {
            return localVarFp.apiLeagueSeasonSeasonIdEventsGet(requestParameters.seasonId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiLeagueIdsIdsGet operation in LeagueApi.
 * @export
 * @interface LeagueApiApiLeagueIdsIdsGetRequest
 */
export interface LeagueApiApiLeagueIdsIdsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LeagueApiApiLeagueIdsIdsGet
     */
    readonly ids: string
}

/**
 * Request parameters for apiLeagueLeagueIdGet operation in LeagueApi.
 * @export
 * @interface LeagueApiApiLeagueLeagueIdGetRequest
 */
export interface LeagueApiApiLeagueLeagueIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LeagueApiApiLeagueLeagueIdGet
     */
    readonly leagueId: string
}

/**
 * Request parameters for apiLeagueSeasonSeasonIdEventsGet operation in LeagueApi.
 * @export
 * @interface LeagueApiApiLeagueSeasonSeasonIdEventsGetRequest
 */
export interface LeagueApiApiLeagueSeasonSeasonIdEventsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LeagueApiApiLeagueSeasonSeasonIdEventsGet
     */
    readonly seasonId: string
}

/**
 * LeagueApi - object-oriented interface
 * @export
 * @class LeagueApi
 * @extends {BaseAPI}
 */
export class LeagueApi extends BaseAPI {
    /**
     * Get league by ids separated by \",\" from Sportradar API
     * @param {LeagueApiApiLeagueIdsIdsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeagueApi
     */
    public apiLeagueIdsIdsGet(requestParameters: LeagueApiApiLeagueIdsIdsGetRequest, options?: RawAxiosRequestConfig) {
        return LeagueApiFp(this.configuration).apiLeagueIdsIdsGet(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get league by id from Sportradar API
     * @param {LeagueApiApiLeagueLeagueIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeagueApi
     */
    public apiLeagueLeagueIdGet(requestParameters: LeagueApiApiLeagueLeagueIdGetRequest, options?: RawAxiosRequestConfig) {
        return LeagueApiFp(this.configuration).apiLeagueLeagueIdGet(requestParameters.leagueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get season events by id from Sportradar API
     * @param {LeagueApiApiLeagueSeasonSeasonIdEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeagueApi
     */
    public apiLeagueSeasonSeasonIdEventsGet(requestParameters: LeagueApiApiLeagueSeasonSeasonIdEventsGetRequest, options?: RawAxiosRequestConfig) {
        return LeagueApiFp(this.configuration).apiLeagueSeasonSeasonIdEventsGet(requestParameters.seasonId, options).then((request) => request(this.axios, this.basePath));
    }
}

